import Card from './components/card'
import Logo from './components/logo'
import Header from './components/header'
import Fields from './components/fields'
import Barcode from './components/barcode'
import HeroImage from './components/hero-image'
import GoogleIcons from './components/google-icons'
import GoogleAppLink from '/components/editor/google/fronts/components/app-link'

const GoogleLoyaltyFront = ({ show, backgroundColour, googleDarkBackgroundColour, fgColour }) => {

  return (
    <>
      <Card backgroundColour={backgroundColour} googleDarkBackgroundColour={googleDarkBackgroundColour} fgColour={fgColour}>
        <GoogleIcons show={show}/>
        <Logo />
        <div className="inset loyalty">
          <Header />
        </div>
        <Barcode />
        <div className="inset">
          <Fields />
          <GoogleAppLink />
        </div>
      </Card>
      <HeroImage/>
    </>
  )
}

export default GoogleLoyaltyFront